import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InactivityTimeoutService } from './core/services/session/inactivity-timeout.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  private readonly inactivityTimeout = inject(InactivityTimeoutService);

  ngOnInit(): void {
    this.inactivityTimeout.start();
  }

  ngOnDestroy(): void {
    this.inactivityTimeout.stop();
  }
}
